import React from "react";
import { getAssets, htmlParse } from "@unisearch/helpers";
import styles from "./contact_hero.module.scss";

const LeadSectionContactHero = ({ pageData }) => {
  return (
    <section className={styles.section_heroform}>
      <div className={styles.heroform_bg_image_wrapper}>
        {pageData?.featureImageSrc && <div className={styles.overlay}></div>}
        <img
          src={
            pageData?.featureImageSrc ||
            getAssets("assets/images/background_with_circle.png")
          }
          alt={pageData?.title}
        />
      </div>
      <div className={`container ${styles.container}`}>
        <div
          className={`${styles.heading_wrapper} ${
            pageData?.featureImageSrc ? "" : styles.color_black
          }`}
        >
          {pageData?.pageTitle && (
            <>{pageData?.pageTitle ? htmlParse(pageData?.pageTitle) : ""}</>
          )}
          {pageData?.dynamicDescription && (
            <div className={styles.sub_title}>
              {pageData?.dynamicDescription
                ? htmlParse(pageData?.dynamicDescription)
                : ""}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default LeadSectionContactHero;
